var render = function render(){var _vm=this,_c=_vm._self._c;return _c('line-chart',{attrs:{"id":"lineChart","data":_vm.localeData,"title":_vm.title,"x-axis":_vm.xAxis,"enable-resize":_vm.enableResize}})
}
var staticRenderFns = []

export { render, staticRenderFns }